import NotificationManager from './notification-manager.service';

export default NotificationManager;
